export const MuiFormHelperText: Partial<Record<any, any>> = {
  root: {
    width: 100,
    fontSize: ".7em",
    color: "red",
    textTransform: "uppercase",
    lineHeight: "1.2em"
  }
};
